import React from 'react'
import Footer from '../Components/Footer/Footer.js'

function Cookie() {
  return (
      <div>
       <div className="Privacidade-background">
        <div className="privacidade-conteudo">
          
          <h1 className="titulo-principal">Cookies</h1>
          
          <p>
            Insira termo de cookies aqui
          </p>
          <p>
            Insira termo de cookies aqui
          </p>
          <p>
            Insira termo de cookies aqui
          </p>
          <p>
            Insira termo de cookies aqui
          </p>
          </div>
        </div>
        <div className="App">
          <Footer/>
        </div>
      </div>
    )
}

export default Cookie;
